import { PeraWalletConnect } from "@perawallet/connect";
import { ChangeAccCbArgs, Connector } from "../interfaces/wallet.interface";
import { BLOCKCHAINS, PROVIDERS } from "../providers";
import { encodeBase64 } from '@libs/shared/helpers/Encoding';
import { PeraChainId } from "../../constants/constants";
import { errorHandler } from "../../_utils/errorHandlers";
import { toast } from "react-toastify";
import { equalsIgnoreCase } from "../../_utils";

export class PeraConnector implements Connector{
  static peraWallet = new PeraWalletConnect({chainId: PeraChainId});
  private static instance: PeraConnector;
  isConnected: boolean = false;
  address: string = null;
  addresses: string[] = [];

  public static getInstance(): PeraConnector {
    if (!PeraConnector.instance) {
      PeraConnector.instance = new PeraConnector();
    }
    return PeraConnector.instance;
  }

  setStateChangeCb(cb: (data: ChangeAccCbArgs) => void): () => void {
    return () => {};
  }

  async connect(chain: BLOCKCHAINS): Promise<BLOCKCHAINS> {
    const addresses = await PeraConnector.peraWallet.reconnectSession();
    if(!PeraConnector.peraWallet.isConnected) {
      const accounts = await PeraConnector.peraWallet.connect();
      this.address = accounts?.[0];
      this.addresses = accounts;
    } else {
      this.address = addresses?.[0];
      this.addresses = addresses;
    }
    this.isConnected = true;
    return chain;
  }

  async disconnect(): Promise<void> {
    await PeraConnector.peraWallet.disconnect();
    this.isConnected = false;
    this.address = null;
    this.addresses = [];
  }

  async switch(): Promise<void> {
    const addresses = await PeraConnector.peraWallet.reconnectSession();
    if (!addresses?.length) {
      try {
        await this.connect(BLOCKCHAINS.ALGORAND);
      } catch (e) { errorHandler(e) }
      return;
    }
    if (addresses?.length === 1) {
      toast.info("You have only one wallet connected, pls connect more to switch", { className: "custom-toast" })
      try {
        await this.disconnect();
        await this.connect(BLOCKCHAINS.ALGORAND);
      } catch (e) { errorHandler(e) }
      return;
    };
    const ind = addresses?.indexOf(this.address);
    const newAddress = ind + 1 > addresses?.length - 1 ? addresses?.[0] : addresses?.[ind + 1];
    this.address = newAddress;
  }


  async reconnect(address = null): Promise<BLOCKCHAINS> {
    const addresses = await PeraConnector.peraWallet.reconnectSession();
    const validAddres = addresses?.some(el => equalsIgnoreCase(el, address)) ? address : addresses?.[0];
    this.isConnected = true;
    this.address = validAddres;
    this.addresses = PeraConnector.peraWallet.connector?.accounts;

    return BLOCKCHAINS.ALGORAND;
  }

  async signMessage(message: string, encoding: BufferEncoding): Promise<string> {
    const signature = await PeraConnector.peraWallet.signData(
      [{
        data: new Uint8Array(Buffer.from(message, encoding)),
        message: "Verify that you owner of the account",
      }],
      this.address,
    );

    return encodeBase64(signature[0]);
  }
}

if (window.Cypress) {
  window.providers =  {
    ...window.providers,
    pera: PeraConnector.peraWallet
  }
}